import { createLogger } from 'shared/services/logger';
import { SimpleMap } from 'shared/stores/core/SimpleMap';

const logger = createLogger('@DiContainer');

export class DiContainer {
  factories = new SimpleMap();

  constructor (store) {
    Object.defineProperty(this, '_store', {
      writable: false,
      value: store
    });
  }

  register (name, klass) {
    this.factories.set(name, klass);
  }

  create (name, ...args) {
    const Factory = this.factories.get(name);

    if (Factory) {
      return new Factory(this._store, ...args);
    } else {
      logger.warn(`Item ${name} is not found`);
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/stores/core/DiContainer.js